export const PDF_MAX_BYTES = 30 * 1024 * 1024;
export const PDF_PREVIEW_EDGE = 2048;
export const PDF_PREVIEW_PIXELS = 4_000_000;
export const PDF_PREVIEW_TIMEOUT_MS = 30_000;

export function pdfPreviewSize(width: number, height: number) {
  if (![width, height].every((value) => Number.isFinite(value) && value > 0))
    throw new Error("Invalid PDF page dimensions.");
  const scale = Math.min(
    2,
    PDF_PREVIEW_EDGE / width,
    PDF_PREVIEW_EDGE / height,
    Math.sqrt(PDF_PREVIEW_PIXELS / (width * height)),
  );
  return {
    scale,
    width: Math.max(1, Math.floor(width * scale)),
    height: Math.max(1, Math.floor(height * scale)),
  };
}
